import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=2a79fdc6&scoped=true&"
import script from "./ColorSelect.vue?vue&type=script&lang=js&"
export * from "./ColorSelect.vue?vue&type=script&lang=js&"
import style0 from "./ColorSelect.vue?vue&type=style&index=0&id=2a79fdc6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a79fdc6",
  null
  
)

export default component.exports